// File: cgp-user-profile-dialog-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile component.
// Other Contributors:

import { Component, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UserProfileService, UserService } from '../../components/mesc/mesc.service';
import { baseConfig } from '../../../config/config.base';
import { DatePipe } from '@angular/common';
import { parseDate } from '@progress/kendo-angular-intl/dist/es/main';

@Component({
    selector: "cgp-app-bar-dialog",
    templateUrl: "./cgp-user-profile-dialog.template.html"
})
export class CgpUserProfileDialogComponent {

    @Input() title;
    @Input() closeLabel;
    moduleGroups: any[] = [];
    moduleName: string;
    groupDisplayName: string;
    adminGroups: any[] = [];
    moduleNames: any[] = [];
    Name: string;
    GMIN: string;
    // @ViewChild(UserProfileComponent) userProfile: UserProfileComponent;

    isImpersonate: boolean = false;

    constructor(public dialogRef: MatDialogRef<CgpUserProfileDialogComponent>, public userProfileService: UserProfileService, public userService: UserService, private datePipe: DatePipe) {
        userProfileService.subscribe(data => {
            try {
                var self = this;
                self.isImpersonate = UserProfileService.getImpersonate();
                if (data) {
                    if (data.length) {
                        self.Name = data[0].Name;
                        self.GMIN = data[0].GMIN;
                        userProfileService.data = data[0];
                        data = data[0];
                    } else {
                        self.GMIN = data['GMIN'];
                        self.Name = data['Name'];
                    }
                    this.userService.read("", true)
                        .then(function (response) {
                            userProfileService.data["LastLogonDate"] = response.filter(function (user) {
                                return user.GMIN.toString() === userProfileService.data["GMIN"];
                            })[0].LastLogonDate + "Z";

                            userProfileService.data["LastLogonDate"] = self.datePipe.transform(
                                parseDate(userProfileService.data["LastLogonDate"]), "M/dd/yyyy, h:mm a");
                        })

                    self.moduleGroups = [];
                    for (var i = 0; i < data["ModuleClaims"].length; i++) {
                        for (var prop in baseConfig.modules.Modules[0]) {
                            self.moduleName = "";
                            if (data["ModuleClaims"][i] === prop.toString()) {
                                self.moduleName = data["ModuleClaims"][i];
                                var moduleGroup = {
                                    moduleName: self.moduleName,
                                    groupNames: []
                                }
                                for (var j = 0; j < baseConfig.modules.Modules[0][prop].length; j++) {
                                    self.groupDisplayName = "";
                                    if (baseConfig.modules.Modules[0][prop][j].isAdminGroup === true) {
                                        baseConfig.modules.Modules[0][prop][j]["appName"] = prop;
                                        this.adminGroups.push(baseConfig.modules.Modules[0][prop][j]);
                                        this.moduleNames.push(prop);
                                    }
                                    // && !baseConfig.modules.Modules[0][prop][j].isAdminGroup
                                    if (data["GroupClaims"].indexOf(baseConfig.modules.Modules[0][prop][j]["GroupName"]) > -1) {
                                        self.groupDisplayName = baseConfig.modules.Modules[0][prop][j]["DisplayName"];
                                    }
                                    if (self.moduleName !== "" && self.groupDisplayName !== "") {
                                        moduleGroup.groupNames.push(self.groupDisplayName);
                                    }
                                }
                                self.moduleGroups.push(moduleGroup);
                            }
                            for (var groupIndex = 0; groupIndex < this.adminGroups.length; groupIndex++) {

                                if (data["GroupClaims"].indexOf(this.adminGroups[groupIndex]["GroupName"]) > -1 && this.moduleNames.indexOf(this.adminGroups[groupIndex]["appName"]) === -1) {
                                    var adminGroupsForApp: any[] = data["GroupClaims"].filter(function (group) {
                                        return group.isAdminGroup === true && this.moduleNames.indexOf(this.adminGroups[groupIndex]["appName"]) === -1;
                                    })

                                    var moduleAdminGroup = {
                                        moduleName: this.adminGroups[groupIndex]["appName"],
                                        groupNames: adminGroupsForApp
                                    }
                                    self.moduleGroups.push(moduleAdminGroup);
                                }
                            }
                        }
                    }
                    if (data["GroupClaims"].indexOf(baseConfig.modules.Modules[0]["MESC"][0]["GroupName"]) > -1) {
                        self.moduleGroups.push({
                            moduleName: "MESC",
                            groupNames: [baseConfig.modules.Modules[0]["MESC"][0]["DisplayName"]]
                        })
                    }
                }
            } catch (e) { }
        })
    }


    toggleImpersonate() {
        UserProfileService.setImpersonate(!this.isImpersonate);
        this.userProfileService.query();
    }
}

